import { useAtom } from '@reatom/npm-react'
import { useCallback } from 'react'
import styled from 'styled-components'
import { match } from 'ts-pattern'

import { useHapticFeedback } from '@blade/ui-kit'
import { Platform } from '@root/entities/platform'
import { useAppRoutes } from '@root/features/routing'
import { settingScreenAtom } from '@root/features/settings/settings-screen/atoms'
import { Gear2Icon } from '@root/shared/ui-kit'
import { NotificationCenter } from '@root/widgets/notification-center'

import { HeaderSearchButton } from './header-search-button'

export const HeaderGuest: React.FC = () => {
  const haptics = useHapticFeedback()
  const [, setSettingsScreen] = useAtom(settingScreenAtom)
  const { navigateToRoot, navigateToPremiumIndex } = useAppRoutes()

  const handleSettingsClick = useCallback(() => {
    haptics.impactOccurred('light')
    setSettingsScreen('main')
    // navigate({ to: 'settings' })
  }, [haptics, setSettingsScreen])

  const handlePlatformChange = (platform: Platform.Platform) => {
    haptics.impactOccurred('light')
    match(platform)
      .with(Platform.Terminal, () => navigateToRoot())
      .with(Platform.Premium, () => navigateToPremiumIndex())
  }

  return (
    <Root>
      <HeaderSearchButton />
      <SettingsButton type="button" onClick={handleSettingsClick}>
        <Gear2Icon size={16} />
      </SettingsButton>
      <NotificationCenter
        value={Platform.Terminal}
        onChange={handlePlatformChange}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 10px;
`

const SettingsButton = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0px;

  color: var(--text-9);
  transition: color 0.15s linear;

  &:hover {
    color: var(--text-10);
  }
`
